<template>
  <div id="sessionStatus" v-if="display == 'true'">
    <div class="status info">
      <h3>Details of your request</h3>

      <ul class="submissionDetails" id="statuses">
        <li v-if="(response != null)">
          <p>Reference number: <span class="barcode">{{ response.recordBarcode }}</span></p>
          <p v-if="(formName !== 'refundRequest')">Status: <span>{{ this.mapLanguage(response.recordStatus) }}</span></p>
        </li>
        <li v-if="(response == null) && (formName === 'refundRequest')">Retrieving your submission reference number</li>
        <li v-if="(response == null) && (formName !== 'refundRequest')">Retrieving your submission details...</li>
      </ul>
    </div>
    
    <div v-if="!(formName == 'reviewSubmittedDeath' || formName == 'refundRequest')">
      <legend>
      <p id="submitted-text">Thank you we have received the application you have submitted and sent you some information.</p>
    </legend>
      <div id="printableForms" v-if="(
        display == 'true' &&
        this.response != null &&
        this.response.printableFormLinks != null &&
        this.response.printableFormLinks.length > 0
      )">
        <h3>{{ downloadsTitle }}</h3>
        <p>{{ downloadsHint }}</p>
        <ul class="printableFormDownloads">
          <li class="actions" v-for="printableForm in this.response.printableFormLinks" :key="printableForm.formName">
            <button id="downloadApplicationForm" v-if="formName='disasterRecovery'">
              <a :download="printableForm.download.fileName" :href="printableForm.download.base64Data">{{
              mapLanguage(printableForm.formName) }}</a>
            </button>
            <a :download="printableForm.download.fileName" :href="printableForm.download.base64Data" v-else>{{
              mapLanguage(printableForm.formName) }}</a>
          </li>
        </ul>
        <br />
      </div>

      <div v-if="formName != 'disasterRecovery' && response != null">
        <h3>What next?</h3>
        <p>Please read the email we have sent you for details about submitting your proof of ID and supporting documents
          (if not uploaded).
        </p>
      </div>

    </div>

    <div id="tasks" v-if="(display == 'true' && this.response != null && this.response.task != null)">
      <h4>{{ this.mapLanguage(this.response.task.taskDefinitionKey) }}</h4>
      <p>
        Each attachment must a PDF, JPEG, TIFF or PNG, be less than 20MB, and special characters must not be in the file
        name.
      </p>
      <p>
        Please <strong>do not</strong> attach scanned or photographed images of your credit card.
      </p>
      <form @submit="submitForm" id="submitForm">
        <ol class="questions">
          <UploadDocumentation
              v-model="uploads"
              :max="10"
          />
          <li id="inProgress">
            <p v-if="inProgress">Submitting your enquiry...</p>
            <p v-else> </p>
          </li>
          <li>
            <fieldset>
              <ul class="actions">
                <li>
                  <strong><button :disabled="uploads.uploading > 0 || inProgress" id="submitButton">{{
                    this.mapLanguage(this.response.task.taskDefinitionKey + '-submit') }}</button></strong>
                </li>
              </ul>
            </fieldset>
          </li>
        </ol>
        <li>
            <PrivacyNotice includeSection107="false"/>
        </li>
      </form>
    </div>
    <hr v-if="formName != 'disasterRecovery'"/>
  </div>
</template>

<script>
import sppapi from '@/sppapi.js';
import UploadDocumentation from '../disasterrecovery/forms/UploadDocumentation.vue';
import PrivacyNotice from '../PrivacyNotice.vue';

export default {
  name: 'SessionStatus',
  props: {
    submissionId: String,
    display: String,
    submitted: Boolean,
    fieldsToFilter: String,
    formName: String
  },
  components: {
    UploadDocumentation,
    PrivacyNotice
  },
  data: function () {
    return {
      response: null,
      loadStatusAttempts: 0,
      timeouts: [],
      supportingFiles: [],
      uploads: {
        uploadIds: [],
        supportingFiles: 1,
        uploading: 0,
        acceptedTypes: '.jpg, .tiff, .png, .jpeg, .pdf',
      },
      inProgress: false,
      taskId: '',
      form: {},
      mapping: {
        'INPROGRESS': 'In progress',
        'WAITING': 'Waiting',
        'ACCEPTED': 'Complete',
        'NEW': 'New',
        'REJECTED': 'Rejected',
        'givenNames': 'Given name(s)',
        'supportingDocumentation1': 'Supporting document 1',
        'supportingDocumentation2': 'Supporting document 2',
        'supportingDocumentation3': 'Supporting document 3',
        'Task_1fkbem2': 'Send us additional documents to complete your application',
        'Task_1fkbem2-submit': 'Submit documents',
        'disasterreplacementconfirmation': 'Download your completed application form'
      }
    }
  },
  computed: {
    downloadsTitle() {
      return "Your application form";
    },
    downloadsHint() {
      if (this.formName === "disasterRecovery") {
        return `You can download and print your application form (if you chose not to submit online) or save it for your records.`
      } else {
        return "You can print your application form for your records, or you can save it now."
      }
    }
  },
  beforeDestroy: function () {
    for (var i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i])
    }
  },
  methods: {
    submitForm: function (event) {
      event.preventDefault()
      sppapi.completeTask(this)
    },
    handleUpload: function (event) {
      const selection = event.target.files[0]
      const ext = selection.name.split('.').pop()
      if (this.uploads.acceptedTypes.indexOf(ext) < 0) {
        document.getElementById(event.target.id).value = ''
        return
      }

      this.uploads.uploading++
      const reader = new FileReader()
      reader.onload = (e) => {
        sppapi.uploadFile(this, selection.name, event.srcElement.name, e.target.result)
      }
      reader.readAsDataURL(selection)
    },
    mapLanguage: function (code) {
      if (this.mapping[code]) {
        return this.mapping[code]
      }

      return code || ''
    },
    loadStatus: function () {
      console.log('Loading status')
      if (!this.submissionId) {
        return
      }

      console.log('Got a submissionId')
      scroll(0, 0);
      sppapi.lookupSession(this.submissionId).then((response) => {
        if (response.status == 'FOUND') {
          this.response = response
          if (response.task) {
            this.taskId = response.task.taskId
          } else {
            this.taskId = null
            this.inputFields = null
          }
        } else {
          this.response = null
          this.inputFields = []
          this.loadStatusAttempts++
          if (this.loadStatusAttempts < 120) {
            this.timeouts.push(setTimeout(() => this.loadStatus(), 500))
          }
        }
      })
    }
  },
  mounted() {
    setTimeout(() => this.loadStatus(), 500)
  }
}
</script>

<style scoped lang="scss">
ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

#sessionStatus {
  margin-top: 0;
}

.submissionDetails {
  margin: 1em 0 0 0;
}

#downloadApplicationForm {
  background-color: #78ba00;
 }

 #downloadApplicationForm a {
  color: #000 !important;
  text-decoration: none !important;
 }

</style>